export class NetworkResponse<T> {
    data?: T
    response: string
    statusCode: number

    constructor(statusCode: number, response: string, data?: T) {
        this.statusCode = statusCode
        this.response = response
        this.data = data
    }
}